<template>
  <div id="wallet-page">
    <PageTitle title="Wallet" />
    <b-container class="pb-4">
      <b-row>
        <b-col cols="12" lg="4">
          <div
            class="wallet-card bg-white dash-card text-center p-2 d-flex justify-content-center align-items-center shadow-xl"
            style="height:200px"
          >
            <div class="wallet-balance">
              <p class="mb-0 text-muted">Balance</p>

              <p
                class="font-weight-bold mb-0 d-block btn btn-sm"
                style="font-size:30px;"
              >
                <Money :value="walletBalance" />
              </p>
            </div>

          </div>

          <div
            class="wallet-card bg-dark text-light dash-card text-center p-2 d-flex justify-content-center align-items-center shadow-xl"
            style="height:100px; margin-top: 30px"
          >
            <div class="wallet-balance">
              <p class="mb-0 text-white">Interests</p>

              <p
                class="font-weight-bold mb-0 d-block btn btn-sm text-white"
                style="font-size:30px;"
              >
                <Money v-if="interests!=null" :value="interests" />
              </p>
            </div>

          </div>

          <b-row class="py-4">
            <b-col cols="6" class="mb-4">
              <button
                v-b-modal.invest-from-wallet-modal
                class="btn w-100 wallet-action dash-card text-left bg-white p-3 action-btn"
              >
                <div
                  class="icon-wrapper icon-wrapper-green p-2 mr-2 d-inline-flex"
                >
                  <i class="ti-plus icon-fx"></i>
                </div>
                <div class="w-100 text-right">Invest</div>
              </button>
            </b-col>
            <b-col cols="6" class="mb-4">
              <button
                v-b-modal.invest-topup-modal
                class="btn w-100 wallet-action dash-card text-left bg-white p-3 action-btn"
              >
                <div
                  class="icon-wrapper icon-wrapper-green p-2 mr-2 d-inline-flex"
                >
                  <i class="ti-plus icon-fx"></i>
                </div>
                <div class="w-100 text-right">Topup</div>
              </button>
            </b-col>
            <b-col cols="6" class="mb-4">
              <button
                v-b-modal.withdraw-modal
                class="wallet-action text-left btn w-100 dash-card bg-white p-3 action-btn"
              >
                <div
                  class="icon-wrapper icon-wrapper-red p-2 mr-2 d-inline-flex"
                >
                  <i class="ti-share icon-fx" aria-hidden="true"></i>
                </div>
                <div class="w-100 text-right">Withdraw</div>
              </button>
            </b-col>
            <b-col cols="6">
              <button
                class="wallet-action text-left btn w-100 dash-card bg-white p-3 action-btn"
                v-b-modal.add-bank-modal
              >
                <div
                  class="icon-wrapper icon-wrapper-red p-2 mr-2 d-inline-flex"
                >
                  <i class="ti-plus icon-fx" aria-hidden="true"></i>
                </div>
                <div class="w-100 text-right">Add Bank</div>
              </button>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="8">
          <b-row>
            <b-col cols="12">
              <h5>Bank Accounts</h5>
              <div
                v-if="bankAccounts.length < 1"
                class="empty-placeholder dash-card bg-white p-4"
              >
                You have not added any bank account. Click "Add Bank" to add a
                bank account
              </div>
              <div
                v-else
                class="list dash-card p-3 w-100 bg-white mb-2"
                v-for="account in bankAccounts"
                :key="account.id"
              >
                <b-row>
                  <b-col>{{ account.accountname }}</b-col>
                  <b-col>{{ account.accountnumber }}</b-col>
                  <b-col class="text-right">
                    <img height="30" :src="bankLogo(account.bankcode)" alt />
                    <b-button
                      @click="deleteBank(account)"
                      size="sm"
                      class="ml-3"
                      variant="danger"
                    >
                      <i class="fas fa-times"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="12" class="mt-4">
              <div class="mb-4" style="min-height:400px">
                <b-tabs v-model="activeTab" small pills card>
                  <b-tab title="Transactions" class="px-0">
                    <WalletTransactions />
                  </b-tab>
                  <b-tab title="Payouts" class="px-0">
                    <PayoutsTable />
                  </b-tab>
                  <b-tab title="Interests" class="px-0">
                    <InterestsTable @total-interests="getInterests" />
                  </b-tab>
                </b-tabs>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <AddBank />
    <DeleteBank :bankAccount="activeBankAccount" />
    <InvestFromWalletModal />
    <Withdraw />
    <TopUp />
    <SuggestInvest :user="userObj" :balance="walletBalance" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageTitle from "@/components/ui/PageTitle";
import InvestFromWalletModal from "./components/InvestFromWalletModal";
import TopUp from "./components/TopUp";
import AddBank from "./components/AddBank";
import DeleteBank from "./components/DeleteBank";
import { UserService, BankAccountService } from "@/services";
import { bankLogo } from "@/utils/helpers";
import Withdraw from "./components/Withdraw";
import WalletTransactions from "./components/WalletTransactions";
import PayoutsTable from "./components/PayoutsTable";
import InterestsTable from "./components/InterestsTable";
import SuggestInvest from "./components/SuggestInvest";
import { formatMoney } from "@/utils/helpers";

export default {
  data() {
    return {
      walletBalance: null,
      bankAccounts: [],
      activeBankAccount: null,
      activeTab: 0,
      interests:null
    };
  },
  computed: {
    ...mapState(["userObj"])
  },
  components: {
    PageTitle,
    AddBank,
    DeleteBank,
    WalletTransactions,
    Withdraw,
    InvestFromWalletModal,
    TopUp,
    PayoutsTable,
    SuggestInvest,
    InterestsTable
  },
  created() {
    const { wallet, bankAccounts } = this.$route.meta.__data;
    this.walletBalance = wallet.balance;
    this.bankAccounts = bankAccounts;
    if (this.walletBalance >= 5000) {
      if (localStorage.getItem("hassuggested") !== "true") {
        this.$bvModal.show("suggest_invest");
      }
      localStorage.setItem("hassuggested", "true");
    }
  },
  async beforeRouteEnter(to, from, next) {
    const { data: wallet } = await UserService.getWallet();
    const { data: bankAccounts } = await BankAccountService.getAll();
    to.meta.__data = { wallet, bankAccounts };
    next();
  },
  methods: {
    formatMoney,
    bankLogo,
    deleteBank(bank) {
      this.activeBankAccount = bank;
      this.$bvModal.show("delete-bank-modal");
    },
    getInterests(interest) {
      this.interests = interest
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}
.action-btn {
    -webkit-box-shadow: 0 20px 25px -5px rgba(0,0,0,.1), 0 10px 10px -5px rgba(0,0,0,.04);
    box-shadow: 0 20px 25px -5px rgba(0,0,0,.1), 0 10px 10px -5px rgba(0,0,0,.04);
    border-radius: 10px;
}

.action-btn:hover {
    -webkit-box-shadow: 0 5px 5px -5px rgba(0,0,0,.1), 0 5px 5px -5px rgba(0,0,0,.04);
    box-shadow: 0 5px 5px -5px rgba(0,0,0,.1), 0 5px 5px -5px rgba(0,0,0,.04);
    -webkit-transition: all .3s ease;
    transition: all .1s ease;
    border-radius: 10px;
}
</style>
